export const gtmEvents = Object.freeze({
  PAGE_VIEW: 'virtualPageView',
  SELECT_SPECIALTY: 'selectExpertise',
  SELECT_LOCATION: 'selectLocal',
  SELECT_LOCATION_LAST_SEARCH: 'localLastSearch',
  GEOLOCATION: 'geoLocation',
  PATIENT_DATA: 'insertBirthday',
  PAYMENT_DATA: 'payment',
  PAYMENT_LAST_SEARCH: 'paymentLastSearch',
  SELECT_HEALTH_CARRIER: 'selectMedicalInsurance',
  SELECT_SLOT: 'scheduling',
  CONFIRM_PATIENT: 'confirmPatient',
  CONFIRM_SCHEDULING: 'confirmScheduling',
  SHOW_FALLBACK: 'showFallback',
  START_LOADING: 'startLoading',
  SCHEDULING_ALERT: 'schedulingAlert',
  STOP_LOADING: 'finishLoading',
  LOGIN: 'login',
  FILTER_DATE: 'filterDate',
  FILTER_DAYS: 'filterDays',
  FILTER_GENDER: 'filterGender',
  FILTER_SCHEDULE_OPTION: 'filterScheduleOption',
  FILTER_SHIFT: 'filterShift',
  FILTER_UNIT: 'filterUnit',
  CLICK_EXTERNAL_WHATSAPP: 'clickExternalWhatsapp',
  RESERVATION_BOOKING_EXPIRED_VIEW_POPUP:
    'reservation_booking_expired_view_popup',
  RESERVATION_BOOKING_EXPIRED_SELECT_CTA:
    'reservation_booking_expired_select_cta',
  FIRST_DATE: 'firstDate',
  SCHEDULE_OTHER_PATIENT: 'scheduleOtherPatient',
  SCHEDULE_SAME_PATIENT: 'scheduleSamePatient',
  POPUP_LOGIN_INCENTIVE_VIEW: 'popup_estimulo_login_view',
  POPUP_LOGIN_INCENTIVE_CTA: 'popup_estimulo_login_cta'
})
